import React from 'react'
import { connect } from 'react-redux';
import GooglePlayBadge from '../../assets/mics/googleplaybadge.png'
import AppstoreBadge from '../../assets/mics/appstorebadge.svg'

const Greeting = (props) => {
    const divStyle = {
        padding: '70px 0',
        textAlign: 'left',
    };

    const { appTitle } = props.theme;
    const { commons } = props;

    return (
        <div style={divStyle}>
            <h2><b>For assets of all shapes and forms</b></h2>
            <p><b>Use {appTitle} to smartly create projects, divide a project into segments, use {commons.drawings}, works as an individual or as a team, {commons.defectMarker} issues, and track them in real-time</b></p>
            <div className="pt-2">
                <a style={{ display: 'inline-block' }} href="https://play.google.com/store/apps/details?id=com.axibuild.assettag_tm1" target="_blank"><img src={GooglePlayBadge} alt="google play" height="80px" /></a>
                <a style={{ display: 'inline-block' }} href="https://apps.apple.com/us/app/assettag-track-manage-solve/id1586255063" target="_blank"><img src={AppstoreBadge} alt="apple store" height="55px" /></a>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        theme: state.theme,
        commons: state.commons,
    }
}

export default connect(mapStateToProps)(Greeting);
